// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid-new__item{position:relative;display:block}.grid-new__item--empty{position:absolute;bottom:0;left:0;right:0}.grid-new__item--hidden{visibility:hidden;margin:0 !important}.grid-new__item--focused{z-index:900}.grid-new__item__body{position:relative;animation-duration:400ms}", ""]);
// Exports
module.exports = exports;
